export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 .17c.72 0 1.45.28 2 .83 1.1 1.1 1.1 2.9 0 4l-2 2-9 9H0v-4l9-9 2-2c.55-.55 1.28-.83 2-.83zm.01 2c-.13 0-.38.03-.59.24l-.58.6 1.17 1.17.59-.59c.21-.22.24-.46.24-.59 0-.13-.02-.38-.24-.59a.843.843 0 00-.59-.24zM2 14h1.17l8.41-8.41-1.17-1.17L2 12.83V14zm6 0h8v2H8v-2z\" fill=\"#000\" fill-opacity=\".3\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};